(function (root) {
  'use strict';
  var propertyNames = ['_Box', '_Box position', '_Source product ID', '_Source variant ID', '_Selected variant'];
  var maxLength = 180000;
  function text(value, limit) { return typeof value === 'string' ? value.slice(0, limit) : ''; }
  function imageUrl(value) {
    try {
      var url = new URL(value, 'https://copperandform.com');
      return url.protocol === 'https:' && ['cdn.shopify.com', 'copperandform.com'].includes(url.hostname) ? url.href : '';
    } catch (_) { return ''; }
  }
  function normalize(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length || cart.items.length > 100) throw new Error('Please add between 1 and 100 items to your order.');
    var total = 0;
    var items = cart.items.map(function (item) {
      var id = Number(item.variant_id || item.id), quantity = Number(item.quantity);
      if (!Number.isSafeInteger(id) || id < 1 || !Number.isInteger(quantity) || quantity < 1 || quantity > 100) throw new Error('An item in your order could not be loaded. Please try again.');
      total += quantity;
      var properties = {};
      propertyNames.forEach(function (name) {
        var value = item.properties && item.properties[name];
        if (typeof value === 'string' || typeof value === 'number') properties[name] = String(value).slice(0, 200);
      });
      return { variant_id: id, quantity: quantity, title: text(item.product_title || item.title, 240), variant_title: text(item.variant_title, 160), image: imageUrl(item.image || (item.featured_image && item.featured_image.url)), properties: properties };
    });
    if (total > 100) throw new Error('Your order can contain up to 100 items.');
    return { version: 1, currency: text(cart.currency, 3) || 'USD', items: items };
  }
  function encode(cart) {
    var bytes = new TextEncoder().encode(JSON.stringify(normalize(cart)));
    var binary = Array.from(bytes, function (b) { return String.fromCharCode(b); }).join('');
    var result = btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    if (result.length > maxLength) throw new Error('Your order could not be transferred. Please contact the store.');
    return result;
  }
  function decode(encoded) {
    if (!encoded || encoded.length > maxLength || !/^[\w-]+$/.test(encoded)) throw new Error('The checkout link is incomplete. Please return to your cart.');
    var binary = atob(encoded.replace(/-/g, '+').replace(/_/g, '/'));
    var data = JSON.parse(new TextDecoder().decode(Uint8Array.from(binary, function (c) { return c.charCodeAt(0); })));
    if (data.version !== 1) throw new Error('Please reopen checkout from your cart.');
    return normalize(data);
  }
  function checkoutUrl(destination, cart, origin) {
    var url = new URL(destination, origin);
    var allowed = ['copperandform.com', 'www.copperandform.com', 'copper-and-form-and-checkout-ethangobles-projects.vercel.app'];
    if (url.protocol !== 'https:' || !allowed.includes(url.hostname) || url.username || url.password || url.port || url.pathname !== '/checkout' || url.search || url.hash) throw new Error('The checkout connection needs to be checked. Please contact the store.');
    // Fragment data is not sent to server/access logs. Never transfer cart tokens,
    // customer notes, arbitrary properties, attribution IDs or payment information.
    url.hash = 'cart=' + encode(cart);
    return url.href;
  }
  function submitCheckout(cart) {
    normalize(cart);
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart';
    form.hidden = true;
    var checkout = document.createElement('input');
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = '';
    form.appendChild(checkout);
    document.body.appendChild(form);
    try { form.requestSubmit(); } catch (error) { form.remove(); throw error; }
  }
  root.CFCheckoutHandoff = Object.freeze({ normalize: normalize, encode: encode, decode: decode, checkoutUrl: checkoutUrl, submitCheckout: submitCheckout });
})(globalThis);
